<template>
  <v-container id="eixo-list">
    <v-row>
      <v-col>{{ editId ? "Editar" : "Adicionar novo" }} Grupo</v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-text-field v-model="groupName" label="Nome do Grupo"></v-text-field>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Pesquise..."
          required
        ></v-text-field>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="values"
          class="elevation-1"
          hide-default-footer
          disable-pagination
          :search="search"
        >
          <template v-slot:item.habilitado="{ item }">
            <AppYesOrNOCombobox :editValue="item"></AppYesOrNOCombobox>
          </template>

          <template slot="no-data">
            <span> Nenhuma Configuração </span>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-row>
      <v-col style="text-align: end">
        <v-btn
          @click="cancel()"
          type="submit"
          color="error"
          text
          style="margin-right: 10px"
          >cancelar</v-btn
        >
        <v-btn color="info" @click="saveConfig()" type="submit">salvar</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import AppYesOrNOCombobox from "./Combobox";
import { groupsAPI } from "../API/groupsAPI";
import { groupsPermissionAPI } from "../API/groupsPermissionAPI";
import { filterConfigText, initialConfig } from "@/modules/configuracao";
import Swal from "sweetalert2";

export default {
  components: {
    AppYesOrNOCombobox,
  },
  data() {
    return {
      headers: [
        { text: "Nome", value: "text", width: "80%" },
        { text: "Habilitado", value: "habilitado", width: "20%" },
      ],
      initialValue: initialConfig,
      values: [],
      search: "",
      editId: this.$route.params.id,
      group: {},
      groupName: "",
    };
  },
  methods: {
    ...mapActions(["setLoading", "setConfig"]),
    async load() {
      if (this.editId) {
        await this.loadEditValue();
      }
      let t = Object.entries(this.initialValue).map((entry) => {
        return { [entry[0]]: entry[1] };
      });

      this.values = t
        .map((item) => {
          return {
            habilitado: Object.values(item)[0],
            text: filterConfigText(Object.keys(item)[0]),
            id: Object.keys(item)[0],
          };
        })
        .filter((item) => item.text)
        .sort(function (a, b) {
          if (a.text < b.text) {
            return -1;
          }
          if (a.text > b.text) {
            return 1;
          }
          return 0;
        });
    },
    async loadEditValue() {
      this.setLoading(true);
      await groupsAPI.getOne(this.editId).then(async ({ data }) => {
        this.groupName = data.nome;
        this.group = data;
        await groupsPermissionAPI.getByGroup(this.editId).then((permission) => {
          if (permission.data) this.initialValue = permission.data;
          this.setLoading(false);
        });
      });
    },
    saveConfig() {
      if (!this.groupName) {
        Swal.fire({
          title: "Atenção!",
          text: `Nome do grupo obrigatório!`,
          confirmButtonText: "Ok",
        });
      } else {
        this.setLoading(true);

        var finalValue = {
          ...this.initialValue,
          ...this.values.reduce((a, v) => ({ ...a, [v.id]: v.habilitado }), {}),
        };
        if (this.editId) {
          this.edit(finalValue);
        } else {
          this.add(finalValue);
        }
      }
    },
    cancel() {
      this.$router.push("/groups");
    },
    add(finalValue) {
      groupsAPI.create({ nome: this.groupName }).then(() => {
        groupsAPI.getLastGroup().then(({ data }) => {
          finalValue = { ...finalValue, usuarioGrupoId: data.usuarioGrupoId };
          groupsPermissionAPI.create(finalValue).then(() => {
            this.setLoading(false);
            this.$router.push("/groups");
          });
        });
      });
    },
    edit(finalValue) {
      let groupUpdate = {
        ...this.group,
        nome: this.groupName,
        usuarioGrupoId: this.editId,
      };
      groupsAPI.update(groupUpdate).then(() => {
        groupsPermissionAPI.getByGroup(this.editId).then(({ data }) => {
          if (data) {
            groupsPermissionAPI.update(finalValue).then(() => {
              this.setLoading(false);
              this.$router.push("/groups");
            });
          } else {
            finalValue = { ...finalValue, usuarioGrupoId: this.editId };
            groupsPermissionAPI.create(finalValue).then(() => {
              this.setLoading(false);
              this.$router.push("/groups");
            });
          }
        });
      });
    },
  },

  mounted() {
    this.load();
  },

  computed: {
    ...mapGetters(["isFullAdmin", "config"]),
  },
};
</script>
